// Versão do app - gerado automaticamente
export const APP_VERSION = '5.43'
export const BUILD_DATE = '20/05/2026, 00:54'
